/* global angular */
( function () {
	'use strict';
	function LabelCtrl ( deepLoadingStatusService, apiService, TOOLTIP_MESSAGES, templateservice, attrCleaner ) {
		var self             = this;
		var labelPlaceholder = 'Type {0} description here';
		var originalModel    = angular.copy( self.model );

		function activate () {
			// to ensure that decrement only happens when label is standalone and not part of another indicator
			if ( !self.defaultText ) {
				deepLoadingStatusService.decrementLoading( null, 'indicator' );
			}
		}

		function getDefaultText () {
			return self.defaultText || 'label';
		}

		function getQuestionText () {
			return ( self.model || {} ).questionText || getDefaultText();
		}

		function getPlaceHolder () {
			return labelPlaceholder.replace( '{0}', getDefaultText() );
		}

		function changeId () {
			var prevId   = ( self.model || {} ).id;
			var oldModel = attrCleaner.removeEmptyAttr( attrCleaner.removeUnnecessaryAttr( angular.copy( originalModel ), 'old' ) );
			var newModel = attrCleaner.removeEmptyAttr( attrCleaner.removeUnnecessaryAttr( angular.copy( self.model ), 'new' ) );

			if ( angular.toJson( newModel ) !== angular.toJson( oldModel ) ) {
				originalModel           = angular.copy( self.model );
				( self.model || {} ).id = apiService.generateUUID();
				templateservice.alterGroupFormula( prevId, ( self.model || {} ).id, self.groupModel );
			}
		}

		function isTypeWithCopy () {
			var type = Number( self.model.type );

			if ( type === 2 || type === 4 || type === 3 ) {
				return true;
			}
		}

		activate();

		self.getPlaceHolder  = getPlaceHolder;
		self.getQuestionText = getQuestionText;
		self.changeId        = changeId;
		self.tooltip         = TOOLTIP_MESSAGES;
		self.isTypeWithCopy  = isTypeWithCopy;
	}

	angular
		.module( 'app.components' )
		.controller( 'LabelCtrl', LabelCtrl );

	LabelCtrl.$inject = [ 'deepLoadingStatusService', 'apiService', 'TOOLTIP_MESSAGES', 'templateservice', 'attrCleaner' ];
} )( );
